export default __webpack_public_path__ + "static/media/cellphone-remove.d474c96d.svg";